<template>
  <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
    <div slot="title" class="el-dialog__title"><div class="title-left"></div><slot name="title">{{$t('personCenterV2.prompt')}}</slot><div class="title-right"></div></div>
    <div class="logout-wrap">
      <div class="logout-img">
        <img src="./assets/images/successfully.png" alt="success">
      </div>
      <div class="logout-content">{{ $t('personCenterV2.success')}}<span class="count">&nbsp;{{ count }}s&nbsp;</span><span>{{ $t('personCenterV2.count') }}</span></div>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="() => handleSure()">{{ $t('personCenterV2.goLogin') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { logoutAjax } from '@/services/loginRegister';

import { clearCookies } from '@/services/common';

export default {
  name: 'logOut',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      CAS_ENABLE: CAS_ENABLE,
    }
  },
  methods: {
    // 登录事件
    handleSure() {
      let self = this;
      if (this.CAS_ENABLE) {
        localStorage.removeItem('myHeaderUser');
        localStorage.removeItem('myUser');
        let callback = encodeURIComponent(`${window.location.origin}/logout?client_name=${CAS_CLIENT_NAME}`);
        window.location.href = `${CAS_LOGOUT_URL}?service=${callback}`;
        clearCookies();
        localStorage.clear();
        sessionStorage.clear();
      } else {
        logoutAjax(Object()).then(function (resp) {
          if (resp.status === 200 && resp.success) {
            clearCookies();
            localStorage.removeItem('userInfo');
            localStorage.removeItem('myUser');
            localStorage.removeItem('companyCode');
            localStorage.removeItem('myCompanyCode');
            localStorage.removeItem('theme');
            sessionStorage.clear();
            self.$router.push({ name: 'login' });
          }
        });
      }
    },
  },
}
</script>
<style lang="less" scoped>
@import './assets/style.less';
</style>
